import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';

export const useRoles = () => {
  return useQuery({
    queryKey: QUERY_KEYS.roles,
    queryFn: () => container.roles.list(),
    staleTime: 10 * 60 * 1000,
  });
};
